export const New = () => {
  return (
    <div className="new">
      <p className="new__title">What's news?</p>
      <p className="new__description">Vouchery i akredytacje wyprzedane</p>
      <p className="new__description">
        Najbliższy oddział na mapie, bankomat joylash lub terminal zostały
        zakończone.
      </p>
      <p className="new__description">
        Face ID i Touch ID qo'llab-quvvatlashi zostały zaimplementowane.
      </p>
      <p className="new__description">
        Dla niektórych użytkowników Androida 10 stworzono bog'liq puzzle z
        powiadomieniami push.
      </p>
      <p className="new__description">
        Zdefiniowaliśmy niewielką ilość oprogramowania dla użytkowników Androida
        w umowach.
      </p>
    </div>
  );
};
